import { gql } from '@apollo/client';
import { AccountInfoShared } from '@retainerclub/shared-api';

export default gql`
  query account($id: ID) {
    account(id: $id) {
      ...AccountInfoShared
      partnerLocationId
    }
  }
  ${AccountInfoShared}
`;
